import Component from 'gia/Component'

import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { log } from 'handlebars';
gsap.registerPlugin(ScrollTrigger);

class Paralax extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)
    this.i = 0

    this.options = {
        distance: 50, 
        top: 1
    };

    this.ref = {
      img: '',
      trigger: '',
   

    }

    this.triggers = []

   
  }

  mount() {


    const start = this.options.top == 0 ? "top top" : "top bottom"
    const distance = this.options.top == 0 ? 0 : this.options.distance

      gsap.fromTo(
        this.ref.img ,
        {
          ease: 'none',
          yPercent: -distance
        },
        {
          scrollTrigger:{
            trigger: this.ref.trigger,
            start: start,
            end: "bottom top",
            scrub:  true
          },
          ease: 'none',
          yPercent: this.options.distance
        }
        )

     

       

}




  unmount() {



  }


}

module.exports = Paralax
